import { render, staticRenderFns } from "./plotly-ribbon-chart.vue?vue&type=template&id=80138e30&"
import script from "./plotly-ribbon-chart.vue?vue&type=script&lang=js&"
export * from "./plotly-ribbon-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports